<script>
  import { onMount } from "svelte";
  import { current_component } from "svelte/internal";

  import { apiCall, apiUpdate } from "../httpCommon";
  import { stringify } from "query-string";
  import Select, { Option } from "@smui/select";
  import HelperText from "@smui/select/helper-text/index";
  import { exclude } from "@smui/common/exclude.js";
  import { forwardEventsBuilder } from "@smui/common/forwardEvents.js";

  export let resource;
  export let value;
  export let idField = "id";
  export let nameField = "name";
  export let helperText = null;
  export let selectFirst = false;
  export let error;
  let getLabel;

  let select;
  $: helperTextVal = error || helperText || "";

  export let filter = {};
  export let sort;
  let items;

  $: invalid = error ? true : false;

  $: props = exclude($$props, [
    "resource",
    "value",
    "error",
    "filter",
    "items"
  ]);

  if (nameField instanceof Function) {
    getLabel = nameField;
  } else {
    getLabel = (row) => row[nameField];
  }

  onMount(async () => {
    try {
      const params = {};
      if (filter && Object.keys(filter).length) {
        params.filter = JSON.stringify(filter);
      }
      if (sort) {
        params.sort = JSON.stringify(sort);
      }
      const response = await apiCall(`/${resource}?${stringify(params)}`);
      items = await response.json();
      if (selectFirst && items.length > 0) {
        value = items[0][idField];
      }
    } catch (e) {
      error = `Loading error: ${e.message}`;
    }
  });

  function changed(e) {
    if (items) {
      value = e.target.value;
    }
  }
</script>

<span>
  <Select
    bind:this={select}
    {value}
    {invalid}
    on:change={changed}
    on:change
    {...props}>
    {#if items}
      <Option value="" />
      <slot {items}>
        {#each items as item}
          <Option value={item[idField]} selected={item[idField] == value}>
            {getLabel(item)}
          </Option>
        {/each}
      </slot>
    {:else}
      <Option disabled>Loading</Option>
    {/if}
  </Select>
  <HelperText validationMsg={error != null}>{helperTextVal}</HelperText>
</span>
